import axiosInstance from '@/services/axiosInstance'

async function cerrarbannernoticias (params = null) {
  const req = {
    url: 'api/usuarios/cerrarbannernoticias',
    method: 'PUT',
    headers: {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    },
    params,
  }
  const res = await axiosInstance(req)
  return res.data
}

export { cerrarbannernoticias }
